import * as API_URLS from '../../services/share-link-invitation/share-link-paths';
import {ShareLinkInvitationService} from '../../services/share-link-invitation/share-link-actions';
import {CopyToClipBoard} from '../general-ui/copy-content-to-clipboard';
import {SELECTION_TRACKING_CONTENT_READY} from '../../services/track-text-selection';

const shareableService = new ShareLinkInvitationService(API_URLS);

class ShareLinkInvitation {
    constructor(root, params) {
        this.root = root;
        this.params = params;
        this.activatedForm = this.root.querySelector('form-activated');
        this.deActivatedForm = this.root.querySelector('form-deactivated');
        this.init();
    }

    init() {
        this.getCompanyParamsForLink();
    }

    getCompanyParamsForLink() {
        return shareableService
            .getShareableLink()
            .then((companyOptions) => {
                const copy = new CopyToClipBoard(this.root);
                this.inputListener(copy);
                Hop.events.trigger(SELECTION_TRACKING_CONTENT_READY, companyOptions.link);
            })
            .catch((error) => {
                if (error.status === 404) {
                    return Hop.logError(Hop.message('company.invitation.modal.group.invite.link.deactivated.label'));
                } else {
                    document.getElementById('invitationLinkModalForm').classList.add('hide');
                    return Hop.logError(error);
                }
            });
    }

    inputListener(copyInstance) {
        this.root.addEventListener('click', () => {
            return this.triggerCopyBtnClickFromInput(copyInstance);
        });
    }

    triggerCopyBtnClickFromInput(copyInstance) {
        copyInstance.copyBtn.click();
    }
}

Hop.defineModule('share-link-invitation', (domRoot, params) => {
    new ShareLinkInvitation(domRoot, params);
});
